import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  CircularProgress,
  Alert
} from '@mui/material';

const LinkUserModal = observer(({ open, onClose, employee, store }) => {
  const [selectedUserId, setSelectedUserId] = useState('');

  const handleSubmit = async () => {
    if (!selectedUserId) return;

    try {
      await store.linkUserToEmployee(employee._id, selectedUserId);
    } catch (err) {
      // Error is handled in the store
    }
  };

  const handleChange = (event) => {
    setSelectedUserId(event.target.value);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Vincular Conta de Usuário
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Vincular uma conta de usuário ao funcionário <strong>{employee?.name}</strong>
          </Typography>

          {store.unlinkedUsers.length === 0 ? (
            <Alert severity="info">
              Não há usuários disponíveis para vincular.
              Todos os usuários já estão vinculados a funcionários.
            </Alert>
          ) : (
            <FormControl fullWidth>
              <InputLabel>Selecione um Usuário</InputLabel>
              <Select
                value={selectedUserId}
                onChange={handleChange}
                label="Selecione um Usuário"
              >
                {store.unlinkedUsers.map((user) => (
                  <MenuItem key={user._id} value={user._id}>
                    <Box>
                      <Typography variant="body1">
                        {user.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {user.email} • {user.role}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          <Alert severity="warning">
            Ao vincular uma conta, o usuário poderá fazer login e gerenciar
            seus próprios horários e agendamentos.
          </Alert>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={store.isLoading || !selectedUserId || store.unlinkedUsers.length === 0}
        >
          {store.isLoading ? <CircularProgress size={20} /> : 'Vincular'}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default LinkUserModal;